<template>
<table
                  class="table table-striped table-light table-hover"
                  id="tablaListasDeAcuerdosPublicadas"
                >
                  <thead class="thead-dark">
                    <tr>
                      <th class="col-9">Lista de Acuerdos</th>
                      <th class="col-3">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-for="(listaDeAcuerdos, indice) in listasDeAcuerdosPublicadas"
                      v-bind:key="listaDeAcuerdos.listaDeAcuerdosId"
                    >
                      <td>{{new Date(listaDeAcuerdos.fechaDePublicacion).toLocaleDateString("es-MX", opcionesFechaLocal)}}. {{indice >0 ? `Lista Anexa ${indice}` : "" }}</td>
                      <td><i
                          class="fas fa-file-download fa-lg"
                          title="Descargar lista de acuerdos"
                          @click="descargarListaDeAcuerdos(listaDeAcuerdos.rutaArchivo)"
                        /></td>
                    </tr>
                    <tr v-if="listasDeAcuerdosPublicadas.length == 0">
                      <td colspan="2">No se encontraron listas de acuerdos.</td>
                    </tr>
                  </tbody>
                </table>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { ListaDeAcuerdos } from "@/components/SIFA/Comun/Modelos/ListaDeAcuerdos.js";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
        listasDeAcuerdosPublicadas: [],
        opcionesFechaLocal: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      }
    };
  },
  props: {prop_listasDeAcuerdosPublicadas: Array[ListaDeAcuerdos]},
  components: {},
  methods: {
    descargarListaDeAcuerdos: function (rutaListaDeAcuerdos) {
        if (rutaListaDeAcuerdos) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaListaDeAcuerdos}`
          a.click();
        }
      },
  },
  mounted: function mounted() {
      if(this.prop_listasDeAcuerdosPublicadas)
        this.listasDeAcuerdosPublicadas = this.prop_listasDeAcuerdosPublicadas;
  },
  computed: {},
};
</script>

<style scoped>
.new-row {
  margin-top: 20px;
}
.fa, .fas{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdosPublicadas/TablaListasDeAcuerdosPublicadas.vue